import React from 'react';
import LocationTemplate from './LocationTemplate';

const ApexPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Apex"
      stateName="North Carolina"
      countyName="Wake"
      zipCodes={["27502", "27523", "27539"]}
      latitude={35.7327}
      longitude={-78.8507}
      population={64729}
      historicalFact="Named for being the highest point on the Chatham Railroad between Richmond and Jacksonville."
      nearbyTowns={[
        "Cary, NC",
        "Raleigh, NC",
        "Holly Springs, NC",
        "Fuquay-Varina, NC",
        "Morrisville, NC",
        "Durham, NC",
        "Chapel Hill, NC",
        "Garner, NC"
      ]}
    />
  );
};

export default ApexPage;